import React, { Fragment, useMemo } from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { Media } from 'reactstrap';
import { Image } from '../../../../AbstractElements';
import userimg from '../../../../assets/images/user/user.png';

const userPath = (row) => row.employeeid || row.uid;

const Userstable = (props) => {

    const allusers = useMemo(
      () => (props.userlist || []).filter((user) => user?.archived !== true),
      [props.userlist]
    );

    const tableColumns = useMemo(() => [

        {name: "Employé", selector: (row) => <Link to={`${process.env.PUBLIC_URL}/dashboard/users/${userPath(row)}`}>
            <Media><Image attrImage={{ className: 'rounded-circle img-30 me-3', src: `${row.photo && row.photo !== ""  ? row.photo :userimg }`, alt: 'Generic placeholder image' }} />
            <Media body className="align-self-center"><div>{row.employeeid || row.uid}</div></Media></Media></Link>, accessor: "link", sortable: true, center: false},
        { name: "Prénom", selector: (row) => row.firstname, sortable: true, center: false, },
        { name: "Nom", selector: (row) => row.lastname, sortable: true, center: false, },
        { name: "Date début", selector: (row) => row.hiredate, sortable: true, center: false, },
        { name: "Bonus", selector: (row) => row.bonus, sortable: true, center: false, },
        { name: "Terminé", selector: (row) => row.terminated ? row.terminationdate : 'non', sortable: true, center: false, },
        { name: "Type", selector: (row) => row.usertype, sortable: true, center: false, }
    ], []);

    
  const paginationComponentOptions = useMemo(() => ({
    rowsPerPageText: 'Utilisateurs par page',
    rangeSeparatorText: 'de',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'Tous',
  }), []);
  



    return (
        <Fragment>
            <div className="table-responsive support-table">
                <DataTable
                    columns={tableColumns}
                    data={allusers}
                    striped={true}
                    center={true}
                    pagination
                    paginationPerPage={100}
                    paginationRowsPerPageOptions={[100, 200, 400, 500]}
                    paginationComponentOptions={paginationComponentOptions}
                />
            </div>
        </Fragment>
    );
};
export default React.memo(Userstable);
